import React, { useEffect, useState } from 'react'
import AutoSuggestionsdata from '../Movie/Autosuggestionsdata'

export default function CreateCollectionTitleandDescription(props) {
  const {
    titleEn,
    titleTe,
    discriptionEn,
    discriptionTe,
    TitleEn,
    TitleTe,
    Discription,
    DiscriptionTe,
    selectImage,
    imagePreview,
    setImagePreview,
    headerLevel,
    setHeaderLevelPersons,
    editMode,
    setHorizontalImage,
    HorizontalImage,
    valueChanged,
    setvalueChanged,
  } = props
  const [autoSuggestion, setAutoSuggestions] = useState([])
  const [filteredNames, setfilteredNames] = useState([])
  const [Name, setName] = useState('')
  const [requiredImageSize, setRequiredImageSize] = useState(true)
  const [duplicate, setDuplicate] = useState(false)
  const SelectionFromSuggestion = async event => {
    const headerLevelPersonsTemp = [...headerLevel]
    const selectedIndex = filteredNames.findIndex(obj => obj.label === event.target.innerText)
    const valueChangedTemp = { ...valueChanged }
    valueChangedTemp.headerLevel = true
    setvalueChanged(valueChangedTemp)
    const isObjectAlreadyExists = (array, idToCheck) =>
    array.some(obj => obj.personID === idToCheck)
    const objectExists = isObjectAlreadyExists(
      headerLevelPersonsTemp,
      autoSuggestion.personHits[selectedIndex].personID,
      )
    headerLevelPersonsTemp.push(autoSuggestion.personHits[selectedIndex])
    setDuplicate(objectExists)
    const arrayObjects = await removeDuplicates(headerLevelPersonsTemp, 'personID')
    setHeaderLevelPersons(arrayObjects)
    setName('')
    setfilteredNames([])
    setAutoSuggestions([])
  }

  function removeDuplicates(arr, idKey) {
    const uniqueIds = new Set()
    const uniqueObjects = []

    for (const obj of arr) {
      if (!uniqueIds.has(obj[idKey])) {
        uniqueIds.add(obj[idKey])
        uniqueObjects.push(obj)
      }
    }

    return uniqueObjects
  }

  const removePersonFromHeaderTaggedPersons = index => {
    const headerLevelPersonsTemp = [...headerLevel]
    headerLevelPersonsTemp.splice(index, 1)
    setHeaderLevelPersons(headerLevelPersonsTemp)
    const valueChangedTemp = { ...valueChanged }
    valueChangedTemp.headerLevel = true
    setvalueChanged(valueChangedTemp)
  }

  const horizontalImage = event => {
    if (event.target.naturalHeight < event.target.naturalWidth) {
      setHorizontalImage(true)
    } else {
      setHorizontalImage(false)
    }
  }

  const handleNameChange = async value => {
    setName(value)
    if (value === '') {
      setfilteredNames([])
    }

    if (value.length >= 3) {
      try {
        if (value === '') {
          setAutoSuggestions([])
          setfilteredNames([])
        }

        const moviePersonData = await AutoSuggestionsdata(value)
        const updatedPersonHits = moviePersonData.personHits.map(e => ({ ...e, personID: e.PK }))
        const updatedData = { ...moviePersonData, personHits: updatedPersonHits }
        setAutoSuggestions(updatedData)

        const filteredNames = moviePersonData
          ? moviePersonData.personHits.map(e => ({ label: e.name_En }))
          : []
        setfilteredNames(filteredNames)
        // setfilteredcrewNamesTelugu(filteredcrewNameste)
      } catch {
        setAutoSuggestions([])
        setfilteredNames([])
        // setfilteredcrewNamesTelugu([])
        // console.warn(error)
      }
    }
  }

const selectHorizontalImage = event => {
  const maxSize = 2 * 1024 * 1024 // 2MB
  if (event.target.files[0].size > maxSize) {
    setRequiredImageSize(false)
    return
  }

  setRequiredImageSize(true)
  selectImage(event)
}

  useEffect(() => {
    if (editMode) {
      setHeaderLevelPersons(headerLevel ? headerLevel : [])
    }
  }, [headerLevel])
  return (
    <>
      <div className='d-flex' style={{ gap: '50px' }}>
        <div>
          <label>
            Title_En:<span className='mandatory'>*</span>
          </label>
          <input
            className='rounded-lg border border-gray-400 w-1/2'
            type='text'
            value={titleEn}
            onChange={event => TitleEn(event.target.value)}
          />
        </div>
        <div>
          <label>
            Title_Te:<span className='mandatory'>*</span>
          </label>
          <input
            type='text'
            value={titleTe}
            className='rounded-lg border border-gray-400 w-1/2'
            onChange={event => TitleTe(event.target.value)}
          />
        </div>
      </div>
      <div className='d-flex' style={{ gap: '50px' }}>
        <div>
          <label>
            Description_En:<span className='mandatory'>*</span>
          </label>
          <textarea
            className='rounded-lg border border-gray-400 '
            // style={{ width: '90%' }}
            type='text'
            value={discriptionEn}
            onChange={event => Discription(event.target.value)}
            rows={8}
            cols={24}
          />
        </div>
        <div>
          <label>
            Description_Te:<span className='mandatory'>*</span>
          </label>
          <textarea
            className='rounded-lg border border-gray-400 '
            type='text'
            value={discriptionTe}
            onChange={event => DiscriptionTe(event.target.value)}
            rows={8}
            cols={24}
          />
        </div>
      </div>
      <div>
        <label>HeaderLevel TaggedPersons:</label>
        {headerLevel && headerLevel.length >= 1 && (
          <div
            className='card'
            style={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'flex-start',
              alignItems: 'center',
              gap: '0.3rem',
              padding: '1rem',
            }}
          >
            {headerLevel &&
              headerLevel.map(
                (persons, personsIndex) => (
                  // persons.map((person, personIndex) => (
                  <div className='TaggedPersonData' key={personsIndex}>
                    <div
                      style={{
                        borderRadius: '1rem',
                        backgroundColor: '#ededed',
                      }}
                      className='d-flex justify-content-start align-items-center pl-2 pr-2 mt-1 mb-1'
                    >
                      <span className='mr-2'>{persons.name_En} </span>
                      <span
                        style={{
                          borderRadius: '50%',
                          color: 'white',
                          backgroundColor: '#474747',
                          padding: '2px 5px',
                          fontSize: '8px',
                        }}
                        onClick={() => removePersonFromHeaderTaggedPersons(personsIndex)}
                      >
                        X
                      </span>
                    </div>
                  </div>
                ),
              )}
          </div>
        )}
        <div>
          {
            <input
              type={'text'}
              className='form-control'
              value={Name}
              onChange={e => handleNameChange(e.target.value)}
            ></input>
          }
          {filteredNames.length >= 1 && (
            <div className='searchfield' style={{ width: '28%' }}>
              {filteredNames.map((Name, NameIndex) => (
                <div key={NameIndex} onClick={event => SelectionFromSuggestion(event)}>
                  <label>{Name.label}</label>
                </div>
              ))}
            </div>
          )}
          {duplicate && <span className='mandatory1'>Person Already Exists</span>}
        </div>
      </div>
      <label>
        CollectionImage:<span className='mandatory'>*</span>
      </label>
      <input
        type='file'
        value={props.imageValue}
        className='form-control m-2'
        accept='image/*'
        placeholder='please enter gallery image'
        onChange={selectHorizontalImage}
        title=' '
        style={{ color: imagePreview ? 'black' : 'transparent' }}
      />
      <div>
        <div
          style={{
            position: 'relative',
            left: '165px',
            top: '36px',
          }}
        >
          {imagePreview.length > 1 && (
            <button
              className='remove btn btn-danger'
              type='button'
              onClick={() => {
                setHorizontalImage(false)
                setImagePreview('')
              }}
            >
              X
            </button>
          )}
        </div>
        {imagePreview && (
          <div style={{ display: 'flex', gap: '10px' }}>
            <img
              src={imagePreview}
              className='posterimage'
              alt='poster-url'
              style={{ maxWidth: '100%', height: 'auto' }}
              onLoad={e => horizontalImage(e)}
            />
          </div>
        )}
        {!HorizontalImage && <span className='mandatory1'>please select a horizontal Image</span>}
        {!requiredImageSize && (
        <span className='mandatory1'>ImageSize should not be more than 2mb </span>
      )}
      </div>
    </>
  )
}
